<template>
  <div class="content pt-3 pb-0" v-if="showOverview">
    <div class="container-fluid">
      <div class="row">
        <!-- Contador de usuarios registrados -->
        <div class="col-xl-3 col-md-6 mb-4">
          <stats-card>
            <div slot="header">
              <i class="bi-people-fill text-primary"></i>
            </div>
            <div slot="content">
              <p class="card-category">Agremiados Registrados</p>
              <h2 class="card-title font-weight-bold">
                {{ Math.round(animatedRegisteredUsers) }}
              </h2>
            </div>
          </stats-card>
        </div>

        <!-- Contador de usuarios aprobados -->
        <div class="col-xl-3 col-md-6 mb-4">
          <stats-card>
            <div slot="header">
              <i class="bi-person-check text-success"></i>
            </div>
            <div slot="content">
              <p class="card-category">Agremiados aprobados</p>
              <h2 class="card-title font-weight-bold">
                {{ Math.round(animatedAcceptedUsers) }}
              </h2>
            </div>
          </stats-card>
        </div>

        <!-- Contador de usuarios pendientes -->
        <div class="col-xl-3 col-md-6 mb-4">
          <stats-card>
            <div slot="header">
              <i class="bi-person-exclamation text-warning"></i>
            </div>
            <div slot="content">
              <p class="card-category">Agremiados por aprobar</p>
              <h2 class="card-title font-weight-bold">
                {{ Math.round(animatedPendingUsers) }}
              </h2>
            </div>
          </stats-card>
        </div>

        <!-- Contador de usuarios rechazados -->
        <div class="col-xl-3 col-md-6 mb-4">
          <stats-card>
            <div slot="header">
              <i class="bi-person-slash text-secondary"></i>
            </div>
            <div slot="content">
              <p class="card-category">Agremiados rechazados</p>
              <h2 class="card-title font-weight-bold">
                {{ Math.round(animatedRejectedUsers) }}
              </h2>
            </div>
          </stats-card>
        </div>
      </div>

      <!-- Gráfica de torta con los estados de suscripción -->
      <div class="row">
        <div class="col-md-8 mb-4">
          <card>
            <template slot="header">
              <div class="d-flex justify-content-between align-items-center">
                <h4 class="title font-weight-bold mt-0 mb-0 col-7">
                  Ingresos mensuales
                </h4>
                <input
                  type="number"
                  class="form-control col-5 col-lg-3"
                  v-model="yearIngress"
                  min="1900"
                  :max="new Date().getFullYear()"
                  placeholder="Año"
                  @change="loadMonthlyIngressData"
                />
              </div>
            </template>
            <div class="d-flex justify-content-center" ref="contentDiv">
              <Bar
                ref="barChart"
                id="my-chart-id"
                :options="chartOptionsPayments"
                :data="chartDataPayments"
                :height="300"
              />
            </div>
          </card>
        </div>
        <div class="col-md-4 mb-4">
          <card>
            <template slot="header">
              <h4 class="title font-weight-bold mt-0 mb-0 text-center">
                Estado de pagos de agremiados
              </h4>
            </template>
            <div class="d-flex justify-content-center">
              <Pie
                id="my-pie-chart"
                :options="chartOptions"
                :data="chartData"
              />
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StatsCard from 'src/components/Cards/StatsCard.vue'
import { mapActions, mapState } from 'vuex'
import { Bar, Pie } from 'vue-chartjs'
import {
  Chart as ChartJS,
  ArcElement,
  BarElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale
} from 'chart.js'

ChartJS.register(
  ArcElement,
  BarElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale
)

export default {
  components: {
    Pie,
    Bar,
    StatsCard
  },
  computed: mapState(['user']),
  data() {
    return {
      showOverview: false,
      // Datos iniciales de usuarios y gráficos
      pending_user: 0,
      accepted_user: 0,
      rejected_user: 0,
      solvent: 0,
      to_confirm: 0,
      insolvent: 0,
      animatedPendingUsers: 0,
      animatedAcceptedUsers: 0,
      animatedRejectedUsers: 0,
      animatedRegisteredUsers: 0,
      yearIngress: new Date().getFullYear(),

      // Gráfica de torta con datos iniciales vacíos
      chartData: {
        labels: ['Solventes', 'Por Confirmar', 'Insolventes'],
        datasets: [
          {
            data: [0, 0, 0],
            backgroundColor: ['#939ba2', '#939ba2', '#939ba2']
          }
        ]
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false
      },

      chartDataPayments: {
        labels: [
          'Enero',
          'Febrero',
          'Marzo',
          'Abril',
          'Mayo',
          'Junio',
          'Julio',
          'Agosto',
          'Septiembre',
          'Octubre',
          'Noviembre',
          'Diciembre'
        ],
        datasets: [
          {
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
          }
        ]
      },
      chartOptionsPayments: {
        responsive: true,
        maintainAspectRatio: false
      }
    }
  },
  methods: {
    ...mapActions(['getData']),

    animateCounter(target, property) {
      const increment = Math.ceil(target / 50)
      const interval = setInterval(() => {
        if (this[property] < target) {
          this[property] += increment
          if (this[property] > target) {
            this[property] = target
          }
        } else {
          this[property] = target
          clearInterval(interval)
        }
      }, 20)
    },

    async loadUserStatusCounters() {
      try {
        const response = await this.getData({
          url: 'analitic/user_status_count'
        })
        console.log(
          response.data.pending_user,
          response.data.accepted_user,
          response.data.rejected_user
        )
        if (response.code === 200) {
          this.animateCounter(
            response.data.pending_user,
            'animatedPendingUsers'
          )
          this.animateCounter(
            response.data.accepted_user,
            'animatedAcceptedUsers'
          )
          this.animateCounter(
            response.data.rejected_user,
            'animatedRejectedUsers'
          )
          this.animateCounter(
            response.data.pending_user +
              response.data.accepted_user +
              response.data.rejected_user,
            'animatedRegisteredUsers'
          )
        }
      } catch (error) {
        console.error(error)
      }
    },

    async loadSubscriptionStatusCounters() {
      try {
        const response = await this.getData({
          url: 'analitic/subscription_status_count'
        })
        if (response.code === 200) {
          this.solvent = response.data.solvent
          this.to_confirm = response.data.to_confirm
          this.insolvent = response.data.insolvent

          // Calcular totales y porcentajes
          const total = this.solvent + this.to_confirm + this.insolvent
          const solventPercent = ((this.solvent / total) * 100).toFixed(1)
          const toConfirmPercent = ((this.to_confirm / total) * 100).toFixed(1)
          const insolventPercent = ((this.insolvent / total) * 100).toFixed(1)

          // Actualizar etiquetas con porcentajes
          this.chartData = {
            labels: [
              `Verificados (${solventPercent}%)`,
              `Por Verificar (${toConfirmPercent}%)`,
              `Por Pagar (${insolventPercent}%)`
            ],
            datasets: [
              {
                data: [this.solvent, this.to_confirm, this.insolvent],
                backgroundColor: ['#2061d3', '#f3a52f', '#6c757d']
              }
            ]
          }
        }
      } catch (error) {
        console.error(error)
      }
    },
    authAdmin() {
      if (this.user.id_role !== 1 && this.user.id_role !== 2) {
        console.log(JSON.stringify(this.user))
        this.$router.push('/admin/events')
      } else {
        this.showOverview = true
      }
    },
    async loadMonthlyIngressData() {
      try {
        const response = await this.getData({
          url: 'analitic/monthly_ingress_on_year',
          params: {
            year: this.yearIngress
          }
        })
        if (response.code === 200) {
          console.log(response.data)

          const monthlyData = response.data

          this.chartDataPayments = {
            labels: [
              'Enero',
              'Febrero',
              'Marzo',
              'Abril',
              'Mayo',
              'Junio',
              'Julio',
              'Agosto',
              'Septiembre',
              'Octubre',
              'Noviembre',
              'Diciembre'
            ],
            datasets: [
              {
                label: 'Ingresos del año: ' + this.yearIngress,
                backgroundColor: '#2061d3',
                data: [
                  monthlyData.Enero,
                  monthlyData.Febrero,
                  monthlyData.Marzo,
                  monthlyData.Abril,
                  monthlyData.Mayo,
                  monthlyData.Junio,
                  monthlyData.Julio,
                  monthlyData.Agosto,
                  monthlyData.Septiembre,
                  monthlyData.Octubre,
                  monthlyData.Noviembre,
                  monthlyData.Diciembre
                ]
              }
            ]
          }
        }
      } catch (error) {
        console.error('Error al cargar los ingresos mensuales:', error)
      }
    }
  },
  mounted() {
    this.authAdmin()
    this.loadUserStatusCounters()
    this.loadSubscriptionStatusCounters()
    this.loadMonthlyIngressData()
  }
}
</script>

<style scoped>
.card-title {
  transition: all 0.2s ease-in-out;
}
</style>
